import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueResource from 'vue-resource'
import VueTimers from 'vue-timers'

Vue.use(VueTimers)
Vue.use(VueResource);
Vue.use(Vuetify)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js